type UnitStatProps = {
	label: string;
	value: string;
};

export function UnitStat({label, value}: UnitStatProps) {
	return (
		<div className="min-w-0 flex-1 flex flex-col gap-1">
			<span className="text-xs text-muted-foreground">{label}</span>
			<span className="text-lg font-semibold tabular-nums">{value}</span>
		</div>
	);
}
